import { render, staticRenderFns } from "./orderWarehousing.vue?vue&type=template&id=9f5ed260&scoped=true&"
import script from "./orderWarehousing.vue?vue&type=script&lang=js&"
export * from "./orderWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./orderWarehousing.vue?vue&type=style&index=0&id=9f5ed260&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5ed260",
  null
  
)

export default component.exports